<template>
  <el-dialog
    title="选择大屏用户"
    :visible.sync="dialogVisible"
    width="600px"
    :modal="true"
    :close-on-click-modal="false"
    @close="onClose"
    append-to-body
  >
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-input
          v-model="searchText"
          placeholder="搜索用户"
          style="width: 200px"
          clearable
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleRefresh">刷新</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="userTable"
      :data="userList"
      @selection-change="handleSelectionChange"
      height="300px"
      border
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="UserId" label="用户ID" width="80"></el-table-column>
      <el-table-column prop="EmpName" label="用户姓名"></el-table-column>
      <el-table-column prop="LoginId" label="登录账号"></el-table-column>
      <el-table-column prop="DpName" label="部门"></el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <span>已选择 {{ selectedUsers.length }} 个用户</span>
      <div>
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import userApi from "@/api/sy/user";

export default {
  name: "ScreenUserSelectDialog",
  data() {
    return {
      dialogVisible: false,
      userList: [],
      selectedUsers: [],
      searchText: "",
      mode: "add", // add 或 remove
      allUsers: [], // 所有用户数据
    };
  },
  methods: {
    open(mode = "add", alreadySelected = []) {
      this.mode = mode;
      this.dialogVisible = true;
      this.selectedUsers = [...alreadySelected];
      this.getUserList();
    },
    getUserList() {
      userApi.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) {
          this.allUsers = res.Data;
          this.userList = res.Data;
          this.filterUsers();
        }
      });
    },
    filterUsers() {
      if (!this.searchText) {
        this.userList = this.allUsers;
      } else {
        const search = this.searchText.toLowerCase();
        this.userList = this.allUsers.filter(
          (u) =>
            (u.EmpName && u.EmpName.toLowerCase().includes(search)) ||
            (u.LoginId && u.LoginId.toLowerCase().includes(search))
        );
      }
    },
    handleSearch() {
      this.filterUsers();
    },
    handleRefresh() {
      this.searchText = "";
      this.getUserList();
    },
    handleSelectionChange(selection) {
      this.selectedUsers = selection;
    },
    onClose() {
      this.dialogVisible = false;
      this.searchText = "";
      this.selectedUsers = [];
    },
    onConfirm() {
      this.$emit("confirm", this.selectedUsers, this.mode);
      this.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
